import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GetStartedRoutingModule } from './get-started-routing.module';
import { GetStartedComponent } from './get-started.component';
import { HeaderComponent } from './header/header.component';
import { GetstartedComponent } from './getstarted/getstarted.component';

@NgModule({
  imports: [
    CommonModule,
    GetStartedRoutingModule
  ],
  declarations: [GetStartedComponent, HeaderComponent, GetstartedComponent]
})
export class GetStartedModule { }
